import {
  createBrowserHistory,
  createHashHistory,
  createRouter as createTanStackRouter,
} from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'

export function getRouter() {
  const useHashHistory = import.meta.env.VITE_NAVIGATION_MODE === 'hash'

  const router = createTanStackRouter({
    routeTree,
    history: useHashHistory ? createHashHistory() : createBrowserHistory(),
    scrollRestoration: true,
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
  })

  return router
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}
